import step1 from "@static/img/accountDetails/step1.png";
import step2 from "@static/img/accountDetails/step2.png";
import step3 from "@static/img/accountDetails/step3.png";
import "./css/PortInExplanation.scss";
import { Card, CardContent, Divider, Grid, Typography } from "@mui/material";

interface IParams {
    alt: string;
    src: string;
    texts: [string, string, string];
    title: string;
}

export const AccountDetailsExplanation = (props: IParams) => {
    const {
        alt,
        src,
        texts: [step1Text, step2Text, step3Text],
        title,
    } = props;

    return (
        <Card>
            <CardContent>
                <Grid container justifyContent="center">
                    <img alt={alt} className="explanation-title__image" src={src} />
                    <Grid item xs={12}>
                        <Typography align="center" color="secondary" gutterBottom variant="normal">
                            {title}:
                        </Typography>
                    </Grid>
                </Grid>
                <Divider />
                <Grid alignItems="flex-start" className="explanation-steps" container spacing={2}>
                    <Grid className="explanation-steps__item" item md={4} xs={12}>
                        <img alt="step 1" src={step1} />
                        <Typography color="primary" variant="normal">
                            {step1Text}
                        </Typography>
                    </Grid>
                    <Grid className="explanation-steps__item" item md={4} xs={12}>
                        <img alt="step 2" src={step2} />
                        <Typography color="primary" variant="normal">
                            {step2Text}
                        </Typography>
                    </Grid>
                    <Grid className="explanation-steps__item" item md={4} xs={12}>
                        <img alt="step 3" src={step3} />
                        <Typography color="primary" variant="normal">
                            {step3Text}
                        </Typography>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};
